/**
 * Global core entry point (critical path JS).
 *
 * - Initializes global utilities, consent management, accessibility, and first-paint UI behaviors.
 * - Loaded at page start for blocking runtime execution.
 * - Shared across both legacy and revamp storefronts.
 * 
 *  * This script is loaded with `defer`, meaning it runs only *after* the HTML is fully parsed.
 * Therefore, no need to wrap logic in `DOMContentLoaded` — the DOM is guaranteed to be ready.
 */

var processInclude = require('app_custom_merge_mufe/util');

processInclude(require('app_custom_mufe_revamp/plugins/jquerySetup'));

$(document).ready(function () {
    processInclude(require('app_custom_mufe_revamp/components/promoBanner'));
    processInclude(require('app_custom_mufe/components/animationBanner'));
    processInclude(require('app_custom_merge_mufe/components/cookie'));
    processInclude(require('app_custom_merge_mufe/components/consentTracking'));
    processInclude(require('app_custom_mufe_revamp/utilities/breakpoints'));
    processInclude(require('app_custom_mufe_revamp/components/menu'));
    processInclude(require('app_custom_mufe_revamp/components/scrollManager'));
    processInclude(require('app_custom_mufe_revamp/components/footer'));
    processInclude(require('app_custom_merge_mufe/triggerify'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('app_custom_merge_mufe/components/accessibilityHelpers'));
    processInclude(require('base/components/toolTip'));
    processInclude(require('app_custom_mufe_revamp/lazyload'));
    processInclude(require('app_custom_mufe_revamp/utilities/screen'));
});

require('app_custom_merge_mufe/thirdParty/bootstrap');
require('app_custom_merge_mufe/components/spinner');
// TODO - Delete slick & owl calls
require('app_custom_merge_mufe/thirdParty/slick');
require('app_custom_mufe/lib/slick-slider-config');
require('app_custom_merge_mufe/thirdParty/owl');
